import { create } from 'zustand';

interface UiState {
  branchId: string | null;
  sidebarCollapsed: boolean;
  mobileNavOpen: boolean;
  /** Explicit open/closed choice per nav group; unset = open only if active. */
  openGroups: Record<string, boolean>;
  setBranch: (id: string | null) => void;
  toggleSidebar: () => void;
  setMobileNav: (open: boolean) => void;
  toggleGroup: (label: string, currentlyOpen: boolean) => void;
}
export const useUi = create<UiState>((set) => ({
  branchId: null,
  sidebarCollapsed: false,
  mobileNavOpen: false,
  openGroups: {},
  setBranch: (branchId) => set({ branchId }),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
  setMobileNav: (mobileNavOpen) => set({ mobileNavOpen }),
  toggleGroup: (label, currentlyOpen) =>
    set((s) => ({
      openGroups: { ...s.openGroups, [label]: !currentlyOpen },
    })),
}));
